import { zeroUnit } from '../../utils'
import { formatDatetime, formatDate } from '@/web-task/filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}

	const { order, injured, setting } = this
	let arr = []
	let includeFormStr = ''
	if (order.includeForm && order.includeForm.length) {
		order.includeForm.forEach((item, index) => {
			let prefix = index === 0 ? '' : '、'
			let suffix = ''
			if (item.insuranceFormCoverage) {
				suffix = `（${zeroUnit(item.insuranceFormCoverage)}保额）`
			}
			includeFormStr += `${prefix}${item.insuranceFormTypeDesc}${suffix}`
		})
	}

	if (!['12'].includes(order.taskType)) {
		arr.push(
			{
				label: '开庭法庭',
				value: order.courtName,
			},
			{
				label: '开庭日期',
				value: formatDatetime(order.courtDate),
			},
			{
				label: '法院案号',
				value: order.courtCaseNo,
			}
		)
	}

	arr.push(
		{
			label: '原告名称',
			value: order.plaintiff,
		},
		{
			label: '标的车属性',
			value: setting.carPropertyMap[order.carProperty],
		},
		{
			label: '是否涉及死亡',
			value: setting.yesNoMap[order.death],
		},
		{
			label: '案件代理类型',
			value: setting.agentTypeMap[order.agentType],
		},
		{
			label: '是否阅卷',
			value: setting.yesNoMap[order.readPaper],
		},
		{
			label: '涉诉金额',
			value: zeroUnit(order.courtAmount, '元'),
		},
		{
			label: '涉诉保单类型',
			value: setting.fornTypeMap[order.includeFormType],
		},
		{
			label: '案件涉诉保单',
			value: includeFormStr,
		},
		{
			label: '应诉要求',
			value: order.taskRequire,
		}
	)
	return {
		title: '案件信息',
		children: arr,
	}
}
